import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { parse } from 'date-fns';
import formatDate from 'date-fns/format';
import _ from 'lodash';
import { linkify } from '../helpers/mapUtils';

class Disclaimer extends Component {
	state = {
		usaCDCLinks: [
			'https://www.iamat.org/country/united-states-of-america/risk/',
			'https://travelhealthpro.org.uk/country/235/united-states#Vaccine_recommendations',
			'https://www.cdc.gov/mmwr/preview/mmwrhtml/rr5507a1.htm',
		],
	};
	updateRoutingLocation() {
		const { location } = this.props;
		this.isSingleTravel = this.props.match.params.hasOwnProperty('country');
		this.isTravel = location.pathname.includes('/travel');
		this.isDiseasePrevalence = location.pathname.includes(`/${window.prevalence_tab_slug}`);
	}

	getPrevalenceUpdatedDate() {
		const { disease } = this.props;
		const originalDateString = disease.date_updated;
		return originalDateString;
	}

	getTravelUpdatedDate() {
		const { countries } = this.props;

		// Find the current countries updated date
		if (this.isSingleTravel) {
			const countryCode = this.props.match.params.country;
			const country = countries.find((country) => _.get(country, 'ISO', '') === countryCode.toUpperCase());
			return this.formatUpdatedDate(parse(_.get(country, 'cms_updated_date', null), 'yyyy-MM-dd', new Date()));
		}

		// Find the most recent updated date across all countries
		const mostRecentDate = countries.reduce((mostRecentDate, country) => {
			const updatedDate = parse(_.get(country, 'cms_updated_date', null), 'yyyy-MM-dd', new Date());
			return updatedDate > mostRecentDate ? updatedDate : mostRecentDate;
		}, 0);
		return this.formatUpdatedDate(mostRecentDate);
	}

	formatUpdatedDate(date) {
		const dateString = formatDate(date, 'MMMM yyyy');
		return dateString;
	}

	render() {
		this.updateRoutingLocation();
		const { hideSeparator = false, disease, disclaimer } = this.props;

		// If we need to use the disease, but it's not available, don't show anything
		if (this.isDiseasePrevalence && !disease) {
			return null;
		}

		const updatedDateString = this.isDiseasePrevalence ? this.getPrevalenceUpdatedDate() : this.getTravelUpdatedDate();

		const showReferences = this.isDiseasePrevalence && disease.reference;
		const isUSA = this.isSingleTravel && this.props.country && this.props.country.ISO === 'US' ? true : false;
		const zinc = disclaimer.zinc;

		return (
			<div className="sidebar-section disclaimer">
				<div className="inner">
					{!hideSeparator && <div className="separator" />}
					<div className="disclaimer-inner">
						{window.vaxiplace ? (
							<Fragment>
								<h4>Disclaimer</h4>
								<p>
									Last updated: {updatedDateString}
									{/* {window.vaxihub ? 'SPANZ.SAPAS.18.10.0368' : 'SPANZ.SAPAS.18.03.0091' } */}
									<span style={{marginLeft:'12px'}}>{zinc}</span>
								</p>
							</Fragment>
						) : (
							<Fragment>
								<h4>Disclaimer</h4>
								<p>
									Last updated: {updatedDateString} <span style={{marginLeft:'12px'}}>{zinc}</span>
								</p>
								<p>
									Be sure to confirm all travel vaccination recommendations with your healthcare practitioner prior to travel
								</p>
							</Fragment>
						)}
						{this.isTravel && (
							<Fragment>
								<p>
									Travel advice for each country is provided by Smartraveller -{' '}
									<a
										href="https://smartraveller.gov.au"
										target="_blank"
										rel="noopener noreferrer"
										data-lightbox="leavesite"
									>
										https://smartraveller.gov.au
									</a>
								</p>
								<p>
									Vaccine recommendations provided by CDC -{' '}
									<a
										href="https://wwwnc.cdc.gov/travel/destinations/list"
										data-lightbox="leavesite"
										target="_blank"
										rel="noopener noreferrer"
									>
										https://wwwnc.cdc.gov/travel/destinations/list
									</a>
									{isUSA ? (
										<Fragment>
											{this.state.usaCDCLinks.map((v, i) => {
												return (
													<span key={i} className="is-block">
														<a href={v} data-lightbox="leavesite" target="_blank" rel="noopener noreferrer">
															{v}
														</a>
													</span>
												);
											})}
										</Fragment>
									) : null}
								</p>
							</Fragment>
						)}
						{showReferences && (
							<Fragment>
								<h4>References</h4>
								<p className="disease-reference" dangerouslySetInnerHTML={{ __html: linkify(disease.reference) }} />
							</Fragment>
						)}
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		disease: state.json.data.prevalence.diseases[props.match.params.disease],
		countries: state.json.data.travel,
		disclaimer: state.json.data.disclaimer,
	};
};

export default withRouter(connect(mapStateToProps)(Disclaimer));
